import {registerGraph, mergeGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('dashboardConsumptionGraph', dashboardConsumptionGraph);

/* @ngInject */
function dashboardConsumptionGraph(GraphService, dashboardGraph, AppearanceService) {
    const isDarkMode = AppearanceService.isDarkModeActive();
    const GraphColors = GraphService.colors;

    return mergeGraph(dashboardGraph(), {
        options: {
            colors: [isDarkMode ? GraphColors.red : GraphColors.lightRed],
            yAxis: {
                min: 0
            },
            plotOptions: {
                area: {
                    fillOpacity: isDarkMode ? 0.5 : 0.2,
                }
            }
        }
    });
}
